import { createContext, useContext } from "react";

import type { HereAndNowTab } from "../tabs";

export type HaNContextValue = {
  tab: HereAndNowTab;
};

export const HaNContext = createContext<HaNContextValue | null>(null);

export const useHaN = () => {
  const context = useContext(HaNContext);

  if (!context) throw new Error("useHaN must be used within HaN.Page");

  return context;
};
